import React, { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import DashboardLayout from '../components/dashboard/layout/DashboardLayout';
import Overview from '../components/dashboard/pages/Overview';
import MyForms from '../components/dashboard/pages/MyForms';
import FormAnalytics from '../components/dashboard/pages/FormAnalytics';
import Account from '../components/dashboard/pages/Account';
import OnboardingModal from '../components/onboarding/OnboardingModal';
import useAuth from '../hooks/useAuth';
import api from '../api';

const Dashboard = () => {
  const { user, isAuthenticated } = useAuth();
  const [showOnboarding, setShowOnboarding] = useState(false);
  const [onboardingChecked, setOnboardingChecked] = useState(false);

  useEffect(() => {
    // Only check onboarding when user is authenticated and hasn't been checked yet
    if (isAuthenticated && user && !onboardingChecked) {
      checkOnboardingStatus();
    }
  }, [user, isAuthenticated, onboardingChecked]);

  const checkOnboardingStatus = async () => {
    try {
      // Check if user has completed onboarding
      const response = await api.get('/users/onboarding-status');

      if (response.success && !response.hasCompletedOnboarding) {
        setShowOnboarding(true);
      }
      setOnboardingChecked(true);
    } catch (error) {
      console.error('Error checking onboarding status:', error);
      setOnboardingChecked(true);
      // Don't show onboarding modal if API check fails
      // The user can manually trigger onboarding from settings if needed
    }
  };

  const handleOnboardingComplete = async (onboardingData) => {
    try {
      // Save onboarding data to backend
      await api.post('/users/onboarding', onboardingData);
      setShowOnboarding(false);
    } catch (error) {
      console.error('Error saving onboarding data:', error);
      // Still close the modal even if save fails
      setShowOnboarding(false);
    }
  };

  // Don't show loading screen, just render dashboard
  // The onboarding check happens in the background

  return (
    <>
      <Routes>
        <Route element={<DashboardLayout />}>
          <Route index element={<Overview />} />
          <Route path="forms" element={<MyForms />} />
          <Route path="analytics/:formId" element={<FormAnalytics />} />
          <Route path="account" element={<Account />} />
        </Route>
      </Routes>

      {/* Onboarding Modal */}
      <OnboardingModal
        isOpen={showOnboarding}
        onComplete={handleOnboardingComplete}
        user={user}
      />
    </>
  );
};

export default Dashboard;